// 编辑内容配置
export const formModel = {
    name: {
        title: '区域名称',
        type: 'input',
        aliasType: 'text',
        value: '',
        rules: [{
            required: true,
            message: '请输入区域名称'
        }]
    },
}

// 表格配置
/**
 * title: 表格标题
 * dataIndex: 后端返回的这个标题的名字
 * filterIndex: 筛选器字段，一般和dataIndex一样，如果是选择型的筛选器，这里填写id字段
 * key: 随便选择dataIndex或filterIndex中的一个
 * type: 筛选器类型，input = 输入框，select = 选择框
 * multi: 如果选择型筛选器需要多选，就写上值为true
 * items: 选择型筛选器必须带上这个，默认为空数组
 */
export const columns = [{
    title: '区域名称',
    dataIndex: 'name',
    filterIndex: 'name',
    key: 'name',
    type: 'input',
    // ...columnPublicConfig
},
{
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: {
        customRender: 'c-action'
    }
}]
